"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface MaterialCard {
  id: string;
  title: string;
  description: React.ReactNode;
  image: string;
  alt: string;
}
const materialCards: MaterialCard[] = [{
  id: "plattor-ytskikt",
  title: "Plattor och ytskikt med karaktär",
  description: "Granitkeramik i storformat ger en lugn och enhetlig yta med färre fogar, vilket kan skapa en modern hotellkänsla. Vill du ha mer liv och dynamik kan plattor med kalkstensstruktur, mönstrad klinker eller klassiskt fiskbensmönster ge rummet ett personligt uttryck.",
  image: "https://proffsbadrum.se/wp-content/uploads/2026/10/proffsbadrum_plattor_ytskikt_772x564.webp?v=agq6bosnnoj",
  alt: "Modernt badrum med stora beige granitkeramikplattor med subtil kalkstensstruktur"
}, {
  id: "harmoniska-fargskalor",
  title: "Harmoniska färgskalor",
  description: "Varma jordtoner, sandfärger, greige och dämpade grå nyanser skapar en rofylld bas som är enkel att trivas med över tid. Genom att låta väggar och golv samspela i närliggande toner upplevs badrummet ofta både större och mer sammanhållet.",
  image: "https://proffsbadrum.se/wp-content/uploads/2026/10/proffsbadrum_harmoniska_fargskalor_772x564-1.webp?v=lpdq53d0df",
  alt: "Harmonisk badrumsmiljö i varma neutrala toner av greige, sand och beige med naturmaterial"
}, {
  id: "detaljer-varumarken",
  title: "Detaljer och utvalda varumärken",
  description: <>
        Blandare, duschdetaljer och beslag fungerar som badrummets smycken. Mattsvart
        ger tydliga kontraster, medan borstad mässing och krom skapar olika uttryck.
        Utforska gärna{" "}
        <Link to="/varumarken" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm">
          våra utvalda varumärken
        </Link>{" "}
        för fler idéer kring design, funktion och materialval.
      </>,
  image: "https://proffsbadrum.se/wp-content/uploads/2026/10/proffsbadrum_detaljer_varumarken_772x564.webp?v=vs61npszcj9",
  alt: "Närbild av stilrena blandare och duschdetaljer i borstad mässing, krom och matt svart"
}];
export default function MaterialFargerDetaljer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="material-farger-detaljer" className="bg-background text-foreground py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-16">
            <h2 className="font-default text-3xl md:text-5xl font-semibold text-foreground tracking-tight">
              Material, färger och tidlösa detaljer
            </h2>
            <div className="mt-4 h-1 w-20 bg-primary mx-auto rounded-full" />
            <p className="mt-6 max-w-3xl mx-auto text-muted-foreground text-base md:text-lg leading-relaxed">
              Valet av material sätter stämningen och karaktären i hela badrummet. Genom att kombinera slitstarka ytskikt med genomtänkta färgval och matchande detaljer skapar du en helhet som håller över tid.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
            {materialCards.map(card => <article key={card.id} className="group bg-card text-card-foreground border border-border/60 rounded-xl overflow-hidden flex flex-col h-full shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="aspect-[4/3] overflow-hidden bg-muted">
                  <img src={card.image} alt={card.alt} width={1600} height={1200} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6 md:p-8 flex flex-col grow">
                  <h3 className="font-default text-xl font-semibold text-foreground mb-3">
                    {card.title}
                  </h3>
                  <p className="text-muted-foreground text-sm md:text-base leading-relaxed grow">
                    {card.description}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}